import { FC } from 'react'

import { ISvgClass } from '../interface'

const ShoppingCartIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M414 4521 c-61 -28 -89 -73 -89 -143 0 -61 17 -94 69 -132 26 -20 44 -21 318 -26 l291 -5 304 -1125 c176 -653 311 -1135 322 -1150 10 -14 33 -35 51 -48 l33 -22 1282 0 1282 0 33 23 c19 12 42 36 52 52 20 35 438 1687 438 1731 0 48 -40 106 -90 132 l-44 22 -1613 0 -1612 0 -11 38 c-5 20 -42 156 -82 301 -72 265 -89 306 -141 345 -27 20 -41 21 -390 24 -337 2 -365 1 -403 -17z m4016 -1021 c0 -9 -80 -334 -111 -452 l-10 -38 -1324 0 c-1252 0 -1324 1 -1329 18 -15 53 -126 470 -126 475 0 4 653 7 1450 7 994 0 1450 -3 1450 -10z m-206 -837 c-4 -16 -33 -127 -64 -248 l-57 -220 -1111 -3 c-1051 -2 -1111 -1 -1116 15 -13 43 -126 472 -126 477 0 3 558 6 1240 6 l1240 0 -6 -27z" />
        <path d="M2283 1686 c-189 -46 -359 -213 -408 -401 -19 -75 -19 -213 0 -285 54 -203 222 -361 430 -405 88 -18 132 -18 220 0 207 43 377 202 430 401 21 78 21 219 0 291 -43 146 -157 288 -282 352 -116 58 -268 76 -390 47z m209 -318 c53 -16 122 -79 143 -130 27 -67 22 -147 -11 -209 -119 -218 -444 -134 -444 115 0 164 151 272 312 224z" />
        <path d="M3746 1684 c-344 -83 -522 -471 -365 -794 43 -88 160 -203 249 -247 228 -109 464 -71 641 106 181 181 220 427 102 655 -116 223 -378 340 -627 280z m260 -340 c157 -97 147 -329 -20 -417 -56 -29 -155 -29 -211 0 -180 94 -175 349 9 435 63 29 159 21 222 -18z" />
      </g>
    </svg>
  )
}

export default ShoppingCartIcon
